import { UpdateTransactionStatusComponent } from './update-transaction-status/update-transaction-status.component';
import { UpdateProfileWizardComponent } from './update-profile-wizard/update-profile-wizard.component';
import { TestProfileWizardComponent } from './test-profile-wizard/test-profile-wizard.component';
import { MdDialogConfig, MdDialogRef, MdDialog } from '@angular/material';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { WarmUpService } from './../../services/warmup/warmup.service';
import { EntityDetailsService } from './../details/entity-details.service';
import { EntityIdDetails } from './../../shared/models/entity-id-details.model';
import { TransactionMonitoringModel } from './entity-transaction-monitoring.model';
import { EntityTransactionMonitoringService } from './entity-transaction-monitoring.service';
import { Component, ElementRef, HostListener, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from 'environments/environment';

import { ConstantsService } from 'app/services/constants-service';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Input } from '@angular/core/src/metadata/directives';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { FinanceService } from 'app/finance/finance.service';
import { BankAccount } from 'app/shared/models/bank-account.model';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/debounceTime';

@Component({
    templateUrl: './entity-transaction-monitoring.component.html'
})

export class EntityTransactionMonitoringComponent implements OnInit, OnDestroy {
    transactionRecords: TransactionMonitoringModel[] = [];
    entityIdDetails: EntityIdDetails;
    tranctionStatus: ApplicationValue[];
    isTransactionLoading = true;
    statusDropDown: any= '';
    selectedStatuses: number[] = [];
    bankAccountFilter: string = '';
    searchText: string = '';
    bankAccounts: BankAccount[] = [];
    selectedTransactions = [];
    selectedSingleTransaction = [];
    transactionCheckBox: boolean;
    dialogRef: MdDialogRef<any>;
    defaultStatusValue = 'all';
    isRecordNumberMoreThanLimit = false;
    pageNumber = 1;
    totalRecords: number;
    
    // Debouncing for filter changes
    private filterChangeSubject = new Subject<void>();
    private filterSubscription: Subscription;
    constructor(
        public entityTransactionMonitoringService: EntityTransactionMonitoringService,
        public entityDetailsService: EntityDetailsService,
        private warmUpService: WarmUpService,
        private viewContainerRef: ViewContainerRef,
        private dialog: MdDialog,
        private financeService: FinanceService,
    ) { }

    ngOnInit() {
        const setTranctionStatus = (values) => { this.tranctionStatus = values; };
        this.warmUpService.getApplicationValueList(ApplicationTypeConstants.TRANSACTION_STATUS, setTranctionStatus);
        this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
        if (this.entityIdDetails && this.entityIdDetails.entityId) {
            this.loadBankAccounts();
            this.loadTransaction();
        } else {
            this.entityDetailsService.entityDetailsUpdated.subscribe(
                (entityDetails) => {
                    this.entityIdDetails = entityDetails;
                    this.loadBankAccounts();
                    this.loadTransaction();
                }
            );
        }

        this.entityTransactionMonitoringService.flagToLoadTransactionRecords.subscribe(flag => {
            if (flag) {
                this.loadTransaction();
                this.selectedTransactions = [];
            }
        });

        // Setup debounced filter changes
        console.log('[ngOnInit] Setting up debounced filter subscription');
        this.filterSubscription = this.filterChangeSubject
            .debounceTime(500) // Wait 500ms after last change
            .subscribe(() => {
                console.log('[Debounced Subscription] Triggered - loading transactions');
                this.pageNumber = 1;
                this.loadTransaction();
            });
        console.log('[ngOnInit] Debounced filter subscription set up, filterChangeSubject:', this.filterChangeSubject);
    }

    ngOnDestroy() {
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
    }

    loadBankAccounts() {
        if (this.entityIdDetails && this.entityIdDetails.entityId) {
            this.financeService.getBankAccountsForEntity(this.entityIdDetails.entityId)
                .subscribe(
                    (accounts: BankAccount[]) => {
                        // Ensure accounts is an array
                        if (Array.isArray(accounts)) {
                            this.bankAccounts = accounts;
                        } else if (accounts) {
                            this.bankAccounts = [accounts];
                        } else {
                            this.bankAccounts = [];
                        }
                    },
                    error => {
                        console.error('Error loading bank accounts:', error);
                        this.bankAccounts = [];
                    }
                );
        }
    }

    loadTransaction() {
        console.log('[loadTransaction] Called');
        this.isTransactionLoading = true;
        // Pass the selectedStatuses array directly, or empty string if none selected
        const statusParam = this.selectedStatuses && this.selectedStatuses.length > 0 ? this.selectedStatuses : '';
        console.log('[loadTransaction] Parameters:', {
            clientId: this.entityIdDetails && this.entityIdDetails.clientId,
            pageNumber: this.pageNumber,
            status: statusParam,
            bankAccount: this.bankAccountFilter,
            searchText: this.searchText
        });
        
        this.entityTransactionMonitoringService.getTransactionDetails(
            this.entityIdDetails.clientId, 
            this.pageNumber, 
            statusParam,
            this.bankAccountFilter,
            this.searchText
        )
            .subscribe(
                response => {
                    console.log('[loadTransaction] Response received:', response);
                    this.transactionRecords = response.arrResult.transactions;
                    this.totalRecords = response.arrResult.totalRecords;
                    this.isTransactionLoading = false;
                    console.log('[loadTransaction] Loaded', this.transactionRecords.length, 'transactions');
                },
                error => {
                    console.error('[loadTransaction] Error loading transactions:', error);
                    this.isTransactionLoading = false;
                }
            );
    }

    
    pageChanged(pageNumber) {
        this.pageNumber = pageNumber;
        this.loadTransaction();
    }

    getApplicationNameFromId(id) {
        const match = this.tranctionStatus.find(type => type.id === id);
        if (match) {
            return match.name;
        }
        return 'N/A';
    }

    getClientBankAccount(transactionRecord: TransactionMonitoringModel): string {
        // First try to use bankAccountNumber if available (from backend)
        if (transactionRecord.bankAccountNumber) {
            return transactionRecord.bankAccountNumber;
        }
        
        // If bankAccountId is available, look it up from our bankAccounts list
        if (transactionRecord.bankAccountId && this.bankAccounts && this.bankAccounts.length > 0) {
            const account = this.bankAccounts.find(acc => acc.accountId === transactionRecord.bankAccountId);
            if (account) {
                return account.accountNumber;
            }
        }
        
        // Check if accountNo matches one of our client's bank accounts
        // The accountNo should be the client's account that the statement was uploaded for
        if (transactionRecord.accountNo) {
            if (this.bankAccounts && this.bankAccounts.length > 0) {
                const account = this.bankAccounts.find(acc => acc.accountNumber === transactionRecord.accountNo);
                if (account) {
                    // accountNo matches a client account, so it's the monitored account
                    return transactionRecord.accountNo;
                }
            } else {
                // If we don't have bank accounts loaded yet, show accountNo as fallback
                // It's likely the client account since transactions come from client statements
                return transactionRecord.accountNo;
            }
        }
        
        // No account information available
        return '-';
    }

    statusFilter() {
        console.log('[statusFilter] Called, selectedStatuses:', this.selectedStatuses);
        // Trigger debounced filter change
        if (this.filterChangeSubject) {
            console.log('[statusFilter] Triggering filterChangeSubject');
            this.filterChangeSubject.next();
        } else {
            console.error('[statusFilter] filterChangeSubject is not initialized!');
        }
    }

    isStatusSelected(statusId: number): boolean {
        const isSelected = this.selectedStatuses && this.selectedStatuses.indexOf(statusId) >= 0;
        return isSelected;
    }

    toggleStatus(statusId: number, event?: any) {
        console.log('[toggleStatus] Called with statusId:', statusId, 'event:', event);
        
        // Stop propagation if event exists and has the method
        if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation();
        }
        
        // Ensure selectedStatuses is initialized
        if (!this.selectedStatuses) {
            console.log('[toggleStatus] Initializing selectedStatuses array');
            this.selectedStatuses = [];
        }
        
        console.log('[toggleStatus] Current selectedStatuses:', this.selectedStatuses);
        
        // Create a copy of the array to ensure change detection works
        const newSelection = [...this.selectedStatuses];
        const index = newSelection.indexOf(statusId);
        
        if (index >= 0) {
            console.log('[toggleStatus] Removing statusId:', statusId);
            newSelection.splice(index, 1);
        } else {
            console.log('[toggleStatus] Adding statusId:', statusId);
            newSelection.push(statusId);
        }
        
        console.log('[toggleStatus] New selectedStatuses:', newSelection);
        
        // Update the array reference to trigger change detection
        this.selectedStatuses = newSelection;
        
        // Trigger debounced filter change
        console.log('[toggleStatus] Calling statusFilter()');
        this.statusFilter();
    }

    areAllStatusesSelected(): boolean {
        if (!this.tranctionStatus || !this.tranctionStatus.length || !this.selectedStatuses) {
            return false;
        }
        // Check if all status IDs are in the selectedStatuses array
        return this.tranctionStatus.length > 0 && 
               this.selectedStatuses.length === this.tranctionStatus.length &&
               this.tranctionStatus.every(status => this.selectedStatuses.indexOf(status.id) >= 0);
    }

    selectAllStatuses(event?: any) {
        console.log('[selectAllStatuses] Called');
        if (event) {
            if (typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }
            if (typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
        }
        
        if (this.tranctionStatus && this.tranctionStatus.length > 0) {
            // Create a new array to ensure change detection
            this.selectedStatuses = this.tranctionStatus.map(status => status.id);
            // Trigger change detection
            this.selectedStatuses = [...this.selectedStatuses];
            console.log('[selectAllStatuses] Selected all statuses:', this.selectedStatuses);
            this.statusFilter();
        }
    }

    deselectAllStatuses(event?: any) {
        console.log('[deselectAllStatuses] Called');
        if (event) {
            if (typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }
            if (typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
        }
        
        // Create a new empty array to ensure change detection
        this.selectedStatuses = [];
        console.log('[deselectAllStatuses] Cleared all statuses');
        this.statusFilter();
    }

    onBankAccountFilterChange() {
        console.log('[onBankAccountFilterChange] Called, bankAccountFilter:', this.bankAccountFilter);
        // Trigger debounced filter change
        if (this.filterChangeSubject) {
            console.log('[onBankAccountFilterChange] Triggering filterChangeSubject');
            this.filterChangeSubject.next();
        } else {
            console.error('[onBankAccountFilterChange] filterChangeSubject is not initialized!');
        }
    }

    onSearchTextChange() {
        if (this.filterChangeSubject) {
            this.filterChangeSubject.next();
        }
    }

    selectTransaction(id) {
        const indexOfSelected = this.selectedTransactions.indexOf(id);
        if (indexOfSelected < 0) {
            this.selectedTransactions.push(id);
        } else {
            this.selectedTransactions.splice(indexOfSelected, 1);
        }
    }

    openUpdateTransactionStatusDialog(transactionRecord?: TransactionMonitoringModel) {
        if (this.selectedTransactions.length > 0 || transactionRecord) {
            this.selectedSingleTransaction = [];
            const config = new MdDialogConfig();
            config.disableClose = true;
            config.viewContainerRef = this.viewContainerRef;
            this.dialogRef = this.dialog.open(UpdateTransactionStatusComponent, config);
            if (transactionRecord) {
                this.dialogRef.componentInstance.selectedSingleTransactionStatus = transactionRecord.status;
                // Although there will be a single Transaction Id in this case,
                // but an array for has been taken to match the format expected
                // in the update transaction logic. This also enables us to make
                // less code changes, either single record is being updated or
                // updation is being done for bulk of records.
                this.selectedSingleTransaction.push(transactionRecord.id);
                this.dialogRef.componentInstance.selectedSingleTransaction = this.selectedSingleTransaction;
            }
            this.dialogRef.componentInstance.tranctionsStatus = this.tranctionStatus;
            this.dialogRef.componentInstance.transactionids = this.selectedTransactions;
            this.dialogRef.afterClosed().subscribe(result => {
                this.dialogRef = null;
            });
        }
        else if (this.selectedTransactions.length == 0 && !transactionRecord) {
            alert("Please select at least one transaction to update status.");
        }
    }

    runRulesForPendingTransactions() {
        if (!this.entityIdDetails || !this.entityIdDetails.clientId) {
            alert("Client information not available");
            return;
        }
        
        if (confirm("This will run rules for all pending transactions. Do you want to continue?")) {
            this.entityTransactionMonitoringService.runRulesForPendingTransactions(this.entityIdDetails.clientId)
                .subscribe(
                    response => {
                        if (response && response.arrResult) {
                            const result = response.arrResult;
                            if (result.success) {
                                alert("Rules executed successfully. " + 
                                    (result.processedCount || 0) + " transaction(s) processed.");
                                // Reload transactions to show updated statuses
                                this.loadTransaction();
                            } else {
                                alert("Failed to run rules: " + (result.error || response.message || "Unknown error"));
                            }
                        } else {
                            alert("Failed to run rules: " + (response.message || "Unknown error"));
                        }
                    },
                    error => {
                        alert("Error running rules: " + (error.message || "Unknown error"));
                    }
                );
        }
    }

    runCleanupOnSelectedTransactions() {
        if (this.selectedTransactions.length === 0) {
            alert("Please select at least one transaction to cleanup.");
            return;
        }
        
        if (confirm("This will run cleanup on " + this.selectedTransactions.length + " selected transaction(s). Do you want to continue?")) {
            this.entityTransactionMonitoringService.cleanupTransactionRecords(this.selectedTransactions)
                .subscribe(
                    response => {
                        if (response && response.arrResult) {
                            const result = response.arrResult;
                            if (result.success) {
                                const message = "Cleanup completed successfully. " + 
                                    (result.recordsModified || 0) + " record(s) modified, " +
                                    (result.recordsSkipped || 0) + " record(s) skipped out of " +
                                    (result.totalRecords || 0) + " total.";
                                alert(message);
                                // Reload transactions to show updated data
                                this.loadTransaction();
                                // Clear selection
                                this.selectedTransactions = [];
                            } else {
                                alert("Failed to cleanup transactions: " + (result.error || response.message || "Unknown error"));
                            }
                        } else {
                            alert("Failed to cleanup transactions: " + (response.message || "Unknown error"));
                        }
                    },
                    error => {
                        alert("Error cleaning up transactions: " + (error.message || "Unknown error"));
                    }
                );
        }
    }

    openUpdateProfileWizard(transactionRecord: TransactionMonitoringModel) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;
        config.width = '800px';
        config.height = '600px';
        config.data = { 
            transactionRecord: transactionRecord 
        };
        
        this.dialogRef = this.dialog.open(UpdateProfileWizardComponent, config);
        
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                // Reload transactions to show updated status
                this.loadTransaction();
            }
        });
    }

    openTestProfileWizard(transactionRecord: TransactionMonitoringModel) {
        const config = new MdDialogConfig();
        config.disableClose = false;
        config.viewContainerRef = this.viewContainerRef;
        config.width = '800px';
        config.height = '600px';
        config.data = { 
            transactionRecord: transactionRecord 
        };
        
        this.dialogRef = this.dialog.open(TestProfileWizardComponent, config);
        
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }

    escalateTransaction(transactionRecord: TransactionMonitoringModel) {
        if (!transactionRecord || !transactionRecord.id) {
            alert("Transaction record information is missing.");
            return;
        }

        if (!this.entityIdDetails || !this.entityIdDetails.clientId) {
            alert("Client information not available.");
            return;
        }

        if (confirm("This will create a task for compliance officers to review this transaction. Do you want to continue?")) {
            this.entityTransactionMonitoringService.escalateTransaction(transactionRecord.id, this.entityIdDetails.clientId)
                .subscribe(
                    response => {
                        if (response && response.arrResult) {
                            const result = response.arrResult;
                            if (result.success) {
                                alert("Transaction escalated successfully. A task has been created for compliance officers.");
                                // Reload transactions to show any status updates
                                this.loadTransaction();
                            } else {
                                alert("Failed to escalate transaction: " + (result.error || result.message || "Unknown error"));
                            }
                        } else {
                            alert("Failed to escalate transaction: " + (response.message || "Unknown error"));
                        }
                    },
                    error => {
                        alert("Error escalating transaction: " + (error.message || "Unknown error"));
                    }
                );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-monitoring/entity-transaction-monitoring.component.ts